import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ServiceTask } from '../model/serviceTask';

@Injectable({
    providedIn: 'root'
  })
  export class ServiceService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllServices() 
    {
      return this._restClientService.load<ServiceTask[]>('service/get');
    }
    
  
}      

    